interface ConnectionsNavDetails {
  title: string;
  route: string;
}

export const ConnectionDocsRouteProperties: {
  partners: ConnectionsNavDetails;
  admin: ConnectionsNavDetails;
  cli: ConnectionsNavDetails;
} = {
  partners: {
    title: "Connect to Shopify through the Partners dashboard",
    route: "connect-to-shopify-through-the-partners-dashboard",
  },
  admin: {
    title: "Connect to Shopify through the store Admin",
    route: "connect-to-shopify-through-the-store-admin",
  },
  cli: { title: "Connect to an embedded Shopify CLI app", route: "connect-to-an-embedded-shopify-cli-app" },
};
